module.exports = __webpack_public_path__ + "img/linus_nobg.4c3d14cd.png";